import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';

import * as WOW from 'src/assets/js/wow.min.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {

  @ViewChild('backgroundImage', {static: true}) backgroundImage: ElementRef;

  ngOnInit() {
   new WOW().init();
  }

  ngAfterViewInit() {

  }
}
